import axios from 'axios'

const state = {}

// getters
const getters = {}

// actions
const actions = {
  async getList(app, pagination) {
    const { page, itemsPerPage, sortBy, toDate, fromDate, search } = pagination
    let order

    if (pagination.sortDesc[0]) {
      order = 'desc'
    } else {
      order = 'asc'
    }

    const params = {
      page, order, itemsPerPage, sortBy: sortBy[0], toDate, fromDate, search
    }

    if (itemsPerPage === -1) {
      params.unpaginated = true
    } else {
      params.page = page
      params.limit = itemsPerPage
    }

    const { data } = await axios.get('/api/v1/questionnaires', {
      params
    })

    return data
  },

  async getById(app, { id }) {
    const { data } = await axios.get(`/api/v1/questionnaires/${id}`)
    return data
  },

  async getByRole(app, { role }) {
    const { data } = await axios.get(`/api/v1/questionnaires?role=${role}&status=ACTIVE&unpaginated=true`)
    return data
  },

  async create(app, payload) {
    const { data } = await axios.post('/api/v1/questionnaires', payload)
    return data
  },

  async download(app, pagination) {
    const { toDate, fromDate } = pagination

    const params = {
      toDate, fromDate
    }

    const response = await axios.get(`/api/v1/download/report`, { responseType: 'blob', params })
    const fileURL = window.URL.createObjectURL(new Blob([response.data]));
    const fileLink = document.createElement('a');

    fileLink.href = fileURL;
    fileLink.setAttribute('download', 'report.xlsx');
    document.body.appendChild(fileLink);

    fileLink.click();
  },

  async update(app, payload) {
    const { data } = await axios.put(`/api/v1/questionnaires/${payload.id}`, payload)
    return data
  },

  async delete(app, payload) {
    const { data } = await axios.delete(`/api/v1/questionnaires/${payload.id}`)
    return data
  },

  async checkCurrentPassword(app, { currentPassword, userId }) {
    const { data } = await axios.post('/api/v1/validation/check_password', {
      current_password: currentPassword,
      user_id: userId,
    })
    return data
  }
}

// mutations
const mutations = {}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
